import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";

const getIP = async () => {
  try {
    const res = await axios.get("https://geolocation-db.com/json/");
    return res.data.IPv4;
  } catch (error) {
    console.log(error);
    return "0.0.0.0";
  }
};

export const apiHome = createApi({
  reducerPath: "apiHome",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL_INTERNAL}/`,
  }),
  // Cache ko bahut der tak retain na karein
  keepUnusedDataFor: 60,

  // Browser tab/window par wapas aane par fresh API call
  refetchOnFocus: true,

  // Network reconnect hone par fresh API call
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getBanner: builder.query({
      query: (url = 7) => `get-banners/${url}`,
    }),
    getMenusData: builder.query({
      query: (benchId = 7) => ({
        url: `get-pagemanagement/${benchId}`,
        method: "GET",
      }),
    }),
    getEventGallery: builder.query({
      query: () => ({
        url: "get-gallery/4",
        method: "GET",
      }),
    }),
    getPhotoGallery: builder.query({
      query: (benchId) => ({
        url: `get-gallery/${benchId}`,
        method: "GET",
      }),
    }),
    getVideoGallery: builder.query({
      query: () => ({
        url: "get-gallery/3",
        method: "GET",
      }),
    }),
    getBottomNav: builder.query({
      query: (url) => ({
        url: `get-modules/${url}`,
        method: "GET",
      }),
    }),
    getMinister: builder.query({
      query: (benchId) => ({
        url: `getMinister/${benchId}`,
        method: "GET",
      }),
    }),
    getFooterNav: builder.query({
      query: (url) => ({
        url: `get-modules/${url}`,
        method: "GET",
      }),
    }),
    getLatestNews: builder.query({
      query: (benchId = 7) => ({
        url: `get-news/${benchId}/whatsnew`,
        method: "GET",
      }),
    }),
    getLastUpdated: builder.query({
      query: () => ({
        url: "getlastupdate",
        method: "GET",
      }),
    }),
    getVisitors: builder.query({
      query: () => ({
        url: "getVisitor",
        method: "GET",
      }),
    }),
    getAddVisitors: builder.query({
      async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
        const ip = await getIP();
        const result = await fetchWithBQ(`addVisitor/${ip}`);
        if (result.error) {
          return { error: result.error };
        }
        return { data: result.data };
      },
    }),
    getFooterNavPage: builder.query({
      query: ({ benchId, menuPageId }) => {
        return {
          url: `getAllTenders/${benchId}/${menuPageId}`,
          method: "GET",
        };
      },
    }),
    getFooterMenusData: builder.query({
      query: (benchId = 7) => ({
        url: `get-footers/${benchId}`,
        method: "GET",
      }),
    }),
    getNotification: builder.query({
      query: (benchId = 7) => ({
        url: `get-news/${benchId}/notification`,
        method: "GET",
      }),
    }),
    getNewsEvents: builder.query({
      query: (benchId = 7) => ({
        url: `get-news/${benchId}/news_event`,
        method: "GET",
      }),
    }),

    getVacancyDownload: builder.query({
      query: ({ benchId = 7, apicategory = "tender" }) => {
        console.log("benchId:", benchId, "apicategory:", apicategory);
        return {
          url: `getvacencies/${benchId}/${apicategory}`,
          method: "GET",
        };
      },
    }),
    getCalendarData: builder.query({
      query: ({ benchId = 7, apicategory = "rti" }) => {
        return {
          url: `getvacencies/${benchId}/${apicategory}`,
          method: "GET",
        };
      },
    }),
    getHolidaysList: builder.query({
      query: (benchId = 7) => {
        return {
          url: `holidays-list/${benchId}`,
          method: "GET",
        };
      },
    }),
    getPresentMembersList: builder.query({
      query: (benchId = 7) => {
        return {
          url: `get_present_members/${benchId}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useGetBannerQuery,
  useGetMenusDataQuery,
  useGetEventGalleryQuery,
  useGetPhotoGalleryQuery,
  useGetVideoGalleryQuery,
  useGetBottomNavQuery,
  useGetMinisterQuery,
  useGetFooterNavQuery,
  useGetLatestNewsQuery,
  useGetLastUpdatedQuery,
  useGetVisitorsQuery,
  useGetAddVisitorsQuery,
  useGetFooterNavPageQuery,
  useGetFooterMenusDataQuery,
  useGetNotificationQuery,
  useGetNewsEventsQuery,
  useGetVacancyDownloadQuery,
  useGetHolidaysListQuery,
  useGetCalendarDataQuery,
  useGetPresentMembersListQuery,
} = apiHome;
